import React, {useContext} from "react";
import {Box, ButtonRow, Title, Form, Section} from "../styles";
import Button from "components/Button";
import AuthViewModel from "../viewModel";
import Input from "../component/Input";
import {FormProvider} from "react-hook-form";

function OneTimePassword() {
  const {isLoadingVerify, methods, onVerify, onRequestOTP} = useContext(AuthViewModel.Context);

  const {handleSubmit} = methods;

  return (
    <Box>
      <Title>Please enter One-time password sent to your e-mail</Title>
      <FormProvider {...methods}>
        <Form onSubmit={handleSubmit(onVerify)}>
          <Section>
            <Input label="One-time password" fieldName="otp" />
            <Button variant="link" style={{textAlign: "right"}} onClick={handleSubmit(onRequestOTP)}>Request a new OTP</Button>
            <ButtonRow>
              <Button type="submit" isLoading={isLoadingVerify} disabled={isLoadingVerify}>{isLoadingVerify ? "Verifying" : "Verify"}</Button>
            </ButtonRow>
          </Section>
        </Form>
      </FormProvider>
    </Box>
  )
}

export default AuthViewModel.withProvider(OneTimePassword);
